import { SearchObject } from "app/common/Model/SearchObject";
import {
  exportRevenueSource,
  getReportRevenueGroupService,
  getReportRevenueGroupServiceDetail,
  reportSalesAllocation,
} from "app/services/ReportService";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";
import { exportVoucherReportItem } from "app/services/VoucherItemService";
import {
  exportServiceGroup,
  pagingServiceGroup,
} from "app/services/ServiceGroupService";
import { PAGESIZE_ALL, SERVICE_UNSPECIFIED_DEPOSIT } from "app/common/LocalConst";
import { pagingAbstractProductService } from "app/services/AbstractProductService";
import moment from "moment";
import { parseVoucherDate } from "app/common/LocalFunction";
import { PageResponse } from "app/common/Model/Shared";
export default class ReportRevenueGroupServiceStore {
  listDataRevenueGroupService = null;
  pageDataRevenueGroupServiceDetail = new PageResponse();
  datataGroupItem = [];
  searchRevenueGroupService = {
    fromDate: new Date(),
    toDate: new Date(),
    departmentIds: [],
    groupNameList: [],
    departmentName: null,
    itemGroupReportName: null,
    voucherDate: null,
  };
  openRevenueGroupServiceDetailPopup = null;
  searchRevenueServiceGroupDetail = {
    ...new SearchObject(),
  };
  dataFormatChart = [];

  constructor() {
    makeAutoObservable(this);
  }

  handleChangeFormSearchRevenueGroupService = (searchRevenueGroupService) => {
    this.searchRevenueGroupService = {
      ...this.searchRevenueGroupService,
      ...searchRevenueGroupService,
    };
    this.getReportRevenueGroupService();
  };

  getReportRevenueGroupService = async () => {
    // Không call API nếu không có cơ sở (bắt buộc)
    if (!this.searchRevenueGroupService.departmentIds || this.searchRevenueGroupService.departmentIds.length === 0) {
      this.listDataRevenueGroupService = null;
      this.dataFormatChart = [];
      return;
    }

    const search = this.normalizeSearchReportVoucher(
      this.searchRevenueGroupService
    );
    return await getReportRevenueGroupService({ ...search })
      .then(({ data }) => {
        this.listDataRevenueGroupService = data;
        let { grandTotal } = data;
        const groupedObject = Object.entries(grandTotal);
        console.log("groupedObject", groupedObject);

        this.dataFormatChart = groupedObject?.map((item) => ({
          name:
            item?.[0] === SERVICE_UNSPECIFIED_DEPOSIT
              ? "Cọc không xác định dịch vụ"
              : item?.[0],
          y: item?.[1],
        }));
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu báo cáo có lỗi");
      });
  };

  getReportRevenueGroupServiceDetail = async () => {
    // Không call API nếu không có cơ sở (bắt buộc)
    if (!this.searchRevenueServiceGroupDetail.departmentIds || this.searchRevenueServiceGroupDetail.departmentIds.length === 0) {
      this.pageDataRevenueGroupServiceDetail = new PageResponse();
      return;
    }

    const search = this.normalizeSearchReportVoucher({
      ...this.searchRevenueServiceGroupDetail,
    });

    return await getReportRevenueGroupServiceDetail({ ...search })
      .then(({ data }) => {
        this.pageDataRevenueGroupServiceDetail = data;
        this.openRevenueGroupServiceDetailPopup = true;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu báo cáo có lỗi");
      });
  };

  handleChangeFormSearchRevenueSearchDetail = (searchObj) => {
    this.searchRevenueServiceGroupDetail = {
      // ...this.searchRevenueServiceGroupDetail,
      pageIndex: this.searchRevenueServiceGroupDetail?.pageIndex,
      pageSize: this.searchRevenueServiceGroupDetail?.pageSize,
      ...searchObj,
    };
    this.getReportRevenueGroupServiceDetail();
  };

  normalizeSearchReportVoucher = (rawSearch = {}) => {
    const {
      departmentIds,
      fromDate,
      toDate,
      groupNameList,
      departmentName,
      itemGroupReportName,
      voucherDate,
      ...rest
    } = rawSearch;

    return {
      ...rest,

      departmentIds:
        departmentIds?.length > 0 ? departmentIds.map((x) => x.id) : null,
      fromDate: fromDate || null,
      toDate: toDate || null,
      voucherDate: voucherDate ? parseVoucherDate(voucherDate) : null,
      itemGroupReportName: itemGroupReportName || null,
      departmentName: departmentName || null,
      groupNameList:
        groupNameList?.length > 0
          ? groupNameList.map((x) =>
            x?.id === SERVICE_UNSPECIFIED_DEPOSIT ? x?.id : x?.name
          )
          : null,
    };
  };

  getListGroupName = async () => {
    try {
      const dataServiceGroup = await pagingServiceGroup({
        pageIndex: 1,
        pageSize: PAGESIZE_ALL,
        isUse: true,
      });

      if (dataServiceGroup?.data?.content?.length > 0) {
        this.datataGroupItem.push(...dataServiceGroup?.data?.content);
      }

      const dataProductGroup = await pagingAbstractProductService({
        pageIndex: 1,
        pageSize: PAGESIZE_ALL,
        isUse: true,
      });

      if (dataProductGroup?.data?.content?.length > 0) {
        this.datataGroupItem.push(...dataProductGroup?.data?.content);
      }
      this.datataGroupItem.push({
        name: "Cọc không xác định dịch vụ",
        id: SERVICE_UNSPECIFIED_DEPOSIT,
      });
    } catch (error) {
      toast.error("Lấy dữ liệu nhóm có lỗi");
    }
  };

  handleExportGroupService = async (searchObj) => {
    const search = this.normalizeSearchReportVoucher({
      ...searchObj,
    });
    try {
      const response = await exportRevenueSource(search);
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "BAO_CAO_DOANH_THU_THEO_NHOM_DICH_VU.xlsx"
        );
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
    } catch (error) {
      console.error("Error export excel report:", error);
    }
  };

  handleCloseRevenueGroupServiceDetailPopup = () => {
    this.openRevenueGroupServiceDetailPopup = null;
    this.pageDataRevenueGroupServiceDetail = new PageResponse();
  };
  resetStore = () => {
    this.datataGroupItem = [];
  };
}
